import { render, staticRenderFns } from "./GoBroadToGoNarrow15.vue?vue&type=template&id=1261235b&"
import script from "./GoBroadToGoNarrow15.vue?vue&type=script&lang=js&"
export * from "./GoBroadToGoNarrow15.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports